const getBase64 = (file: File) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });

function getExtension(fileName: string) {
  return fileName ? fileName.split('.').pop() : 'blank-image';
}

export { getBase64, getExtension };
